<template>
  <div class="table-wrapper" v-if="this.precent > 0">
    <p class="table-title">
      <span>
        <i />
        重仓基金({{this.precent}}%)
      </span>
      <span class="date-title" >{{holddate}}
        </span>
    </p>

    <div class="thead">
      <div v-for="(hItem,hIndex) in tHeadData" :key="hIndex">
        <img src alt v-if="hIndex === 0" />
        <span class="hItem-text">{{hItem}}</span>
      </div>
    </div>

    <div>
      <div v-for="(bItem,bIndex) in tBodyData"
       :key="bIndex" class="bItem" @click="cLickFund(bItem)">
        <div>
          <span class="bItem-name">{{bItem.name}}</span>
        </div>
        <div>
          <span class="bItem-proportion">{{bItem.proportion}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  detailPushPage,
} from '@/utils/nativeBridge';
import StoreManger from '@/utils/FundHQJHManger';

export default {
  name: 'FundTablePositionszj',
  components: {},
  data() {
    return {
      precent: 0,
      fundCode: '',
      nativeData: {},
      dataCc: {},
      holddate: '',
      tHeadData: ['基金名称', '', '', '持仓占比'],
      tBodyData: new Array(5).fill({
        name: '****',
        code: '----',
        price: '--',
        priceRatio: '--',
        proportion: '--',
        previous: '--',
      }),
    };
  },
  mounted() {
  },
  methods: {
    cLickFund(item) {
      if (item) {
        const fund = item.TZJJDM;
        const linkTo = `fund://page/funddetail?fundcode=${fund}&id=${fund}`;
        detailPushPage({
          type: 1,
          url: linkTo,
        });
      }
    },
    async render(iscache) {
      this.nativeData = this.$store.state.native.fund;
      this.fundCode = this.nativeData.fundCode;
      this.loadData(iscache);
      this.holddate = StoreManger.getFundJJCCExpansion();
    },
    clickMore() {
      const baseInfo = StoreManger.getFundJJXQ();
      const name = StoreManger.getFundJJXQNAME(baseInfo);
      const code = StoreManger.getFundJJXQCODE(baseInfo);

      detailPushPage({
        appId: 'b34ccfc4ed9a4af4a4880fee485cf417',
        url: '/pages/Index',
        params: {
          fundCode: code,
          fundName: name,
          index: '1',
        },
      });
    },
    async loadData() {
      const basedata = StoreManger.getFundJJCC();
      if (basedata) {
        this.dataCc = basedata.InverstPosition;
      }
      if (!this.dataCc) {
        return;
      }
      const datas = this.dataCc.fundfofs;
      // console.log(datas);
      const list = [];
      let showTotal = 0;
      for (let i = 0; i < datas.length; i += 1) {
        const data = datas[i];
        const { TZJJMC, TZJJDM, ZJZBL } = data;
        const ZJZBLper = `${parseFloat(ZJZBL).toFixed(2)}%`;
        list.push({
          name: TZJJMC,
          TZJJDM,
          proportion: ZJZBLper,
        });
        showTotal = parseFloat(showTotal) + parseFloat(ZJZBL);
      }
      this.precent = `${showTotal.toFixed(2)}`;
      if (list.length > 5) {
        list.splice(5, list.length - 5);
      }
      this.tBodyData = list;
      this.loadPrice(this.tBodyData);
    },
    loadPrice(fundStocks) {
      if (fundStocks && fundStocks.length > 0) {
        const tempDatas = [];
        for (let i = 0; i < this.tBodyData.length; i += 1) {
          const storeHouseData = this.tBodyData[i];
          const item = {
            name: storeHouseData.name,
            TZJJDM: storeHouseData.TZJJDM,
            proportion: storeHouseData.proportion,
          };
          tempDatas.push(item);
        }
        this.tBodyData = tempDatas;
      }
    },
    upDown(value) {
      const newV = parseFloat(value);
      if (newV > 0) {
        return 'red';
      }
      if (newV < 0) {
        return 'green';
      }
      return 'gray';
    },
  },
};
</script>

<style scoped lang="less">
.table-wrapper {
  padding: 0 24px;
}
.gray {
  color: @app-color-stay;
}
.red {
  color: @app-color-up;
}
.green {
  color: @app-color-down;
}
.table-title {
  font-family: DINAlternate-Bold;
  font-size: 30px;
  color: #000000;
  line-height: 84px;
  height: 84px;
  text-align: left;
  display: flex;
  justify-content: space-between;
  align-items: center;
  i {
    width: 10px;
    height: 10px;
    background-color: #D699FF;
    margin-right: 10px;
    display: inline-block;
    border-radius: 50%;
    position: relative;
  }
}

.thead {
  display: flex;
  justify-content: space-between;
  > div {
    flex: 1;
    &:nth-child(1) {
      text-align: left;
    }
    &:nth-last-child(1) {
      text-align: right;
    }
  }
}

.hItem-text {
  height: 40px;
  font-family: PingFangSC-Regular;
  font-size: 28px;
  color: #999999;
  line-height: 40px;
}

.bItem {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 30px 0;
  > div {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    &:nth-child(1) {
      align-items: flex-start;
    }
    &:nth-last-child(1) {
      align-items: flex-end;
    }
  }
  &-name {
    font-family: PingFangSC-Regular;
    font-size: 30px;
    color: #000000;
    line-height: 30px;
    margin-bottom: 10px;
  }
  &-code {
    font-family: DINAlternate-Bold;
    font-size: 24px;
    color: #666666;
    text-align: right;
    line-height: 24px;
  }
  &-price {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    text-align: center;
    line-height: 30px;
    margin-bottom: 10px;
  }
  &-priceRatio {
    font-family: DINAlternate-Bold;
    font-size: 24px;
    text-align: center;
    line-height: 24px;
  }
  &-proportion {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: center;
    line-height: 30px;
  }
  &-previous {
    font-family: DINAlternate-Bold;
    font-size: 32px;
    color: #000000;
    text-align: right;
    line-height: 30px;
  }
}

.date-title{
  color: #999999;
  text-align: right;
  align-items: center;
  display: flex;
}
.right-arrow {
  margin-left: 5px;
  width: 32px;
  height: 32px;
}
</style>
